export default "__VITE_ASSET__n8GMi0SN__"